export const PAIR_PATH = '/data/pair';
export const PAIR_REPRESENTATIVE_PATH = '/data/token';
